import { useComponentRegistry } from '@bem-react/di';

import { IRegistry } from 'client/platforms/desktop/components/lego/registry';

export function useLegoComponents() {
    return useComponentRegistry<IRegistry>('lego');
}
